import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionSummary, AccordionDetails, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useBookingByIdWithMetaQueryObserver } from "../../../../../../../api/services";
import { RouteParams } from "../../../../../../../types";
import { FormTextField } from "../../../../../../../components/fields";
import { IFormValues } from "../../../../../types";

const SubscriptionDetails = () => {

    const { t } = useTranslation('booking');

    const { id } = useParams<RouteParams>();

    const bookingQuery = useBookingByIdWithMetaQueryObserver(id);

    return (
        <Accordion defaultExpanded>
            <AccordionSummary expandIcon={<ExpandMore />}>
                <Typography variant="h5">
                    {t('label.subscriptionDetails')}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <Grid container rowSpacing={1} columnSpacing={3}>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={t('label.subscriptionNumber')}
                            value={bookingQuery.data?.booking.subscriptionNumber ?? ''}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={t('label.subscriptionMonth')}
                            value={bookingQuery.data?.booking.subscriptionMonth ?? 0}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={t('label.renewal')}
                            value={bookingQuery.data?.booking.renewal ? t('label.yes') : t('label.no')}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={t('label.packageSwap')}
                            value={bookingQuery.data?.booking.packageSwap ? t('label.yes') : t('label.no')}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <TextField
                            label={t('label.carSwap')}
                            value={bookingQuery.data?.booking.carSwap ? t('label.yes') : t('label.no')}
                            fullWidth
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="subscriptionDetail.dropoffDescLocation"
                            label={t('label.dropoffLocationSubscription')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    {/*
                        <Grid item xs={12} sm={6}>
                            <FormTextField<IFormValues>
                                name="subscriptionDetail.dropoffLocation"
                                label={t('label.dropoffLocationSubscription')}
                                InputProps={{
                                    readOnly: true
                                }}
                                InputLabelProps={{
                                    shrink: true
                                }}
                            />
                        </Grid>
                    */}
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="subscriptionDetail.dropoffDate"
                            label={t('label.dropoffDateSubscription')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                        <FormTextField<IFormValues>
                            name="subscriptionDetail.dropoffTime"
                            label={t('label.dropoffTimeSubscription')}
                            InputProps={{
                                readOnly: true
                            }}
                            InputLabelProps={{
                                shrink: true
                            }}
                        />
                    </Grid>
                </Grid>
            </AccordionDetails>
        </Accordion>
    );
};

export default SubscriptionDetails;
